import {Card, CardContent, Typography, Button, Stack, CardActions} from '@mui/material';
import React, {Fragment} from 'react';
import {IconIllustration} from 'presentation/components';
import {translations} from 'presentation/translations-new';
import {useAccountInformation} from 'presentation/pages/private/hooks';
import {useNavigate} from 'react-router-dom';
import {HomeEnum} from 'presentation/constants';

const {showDetails} = translations['pt-br'].commons;
const {line1, line2} = translations['pt-br'].privateFlow.home.earlyAccess.reminderCard;

export function EarlyAccessCard() {
	const {firstNameBeneficiary, beneficiary} = useAccountInformation();
	const navigate = useNavigate();

	return (
		<Fragment>
			<Card elevation={0}>
				<CardContent>
					<Stack direction="row" gap={1.5} alignItems="flex-start">
						<IconIllustration
							customIconName="warning"
							variant="primary"
							size="medium"
						/>
						<Typography variant="body1">
							{firstNameBeneficiary}
							{line1} <strong>{beneficiary.dtAdesaoC}</strong>
							{line2}
						</Typography>
					</Stack>
				</CardContent>

				<CardActions sx={{padding: '0 16px 16px'}}>
					<Button
						onClick={() => navigate(HomeEnum.EARLY_ACCESS)}
						variant="outlined"
						fullWidth>
						{showDetails}
					</Button>
				</CardActions>
			</Card>
		</Fragment>
	);
}
